<script>
import {DateUtil} from '@/utils/date.js'
import {StringUtil} from '@/utils/StringUtil'

export default {
  data () {
    return {
    }
  },
  created () {
  },
  props: {
    title: {type: String, default: ''},
    type: {type: String, default: 'info'},
    func: {type: String, default: 'login'},
    vehicle: {
      vehicleName: {type: String, default: ''},
      vehicleId: {type: String, default: ''},
      displayVehicleId: {type: String, default: ''},
      vehicleType: {type: String, default: ''},
      vehiclePlate: {type: String, default: ''},
      passengerNumber: {type: String, default: ''},
      joinDate: {type: String, default: ''},
      note: {type: String, default: null},
      vehiclePhotoUrl: {type: String, default: null},
      blockStart: {type: String, default: ''},
      blockEnd: {type: String, default: ''},
      blockNote: {type: String, default: null},
      transportKind: {},
      transportId: {},
      transportName: {},
    },
    option: {
      img: null,
      file: null
    },
  },
  computed: {
    blockStart: function () {
      return DateUtil.yearWeekHourMinute(this.vehicle.blockStart)
    },
    blockEnd: function () {
      return DateUtil.yearWeekHourMinute(this.vehicle.blockEnd)
    }
  },
  methods: {
    // 车辆登录
    login () {
      console.log('login')
      if (StringUtil.isEmpty(this.vehicle.note)) {
        this.vehicle.note = null
      }

      new Promise((resolve, reject) => {
        if (this.option.file !== null) {
          let file = this.option.file
          let formData = new FormData()
          formData.append('uploadFile', file)
          this.$axios.post('vehicle/saveVehicleImage', formData)
            .then((response) => {
              this.vehicle.vehiclePhotoUrl = response.data.pictureUrl
              resolve()
            })
            .catch((error) => {
              console.log(error)
            })
        } else {
          this.vehicle.vehiclePhotoUrl = null
          resolve()
        }
      }).then(() => {
        this.$axios.post('vehicle/registVehicle', this.vehicle)
          .then((response) => {
            let vehicleId = response.data.vehicleId
            this.vehicle.vehicleId = vehicleId
            this.$router.push({name: 'VehicleList'})
          })
          .catch(function (error) {
            console.log(error)
          })
      })
    },
    // 车辆编辑
    editor () {
      console.log('editor')
      if (StringUtil.isEmpty(this.vehicle.note)) {
        this.vehicle.note = null
      }

      new Promise((resolve, reject) => {
        if (this.option.img === this.vehicle.vehiclePhotoUrl) {
          resolve()
        } else if (this.option.file !== null) {
          let file = this.option.file

          let formData = new FormData()
          if (this.vehicle.vehiclePhotoUrl) {
            formData.append('fileName', this.vehicle.vehiclePhotoUrl)
          }

          formData.append('uploadFile', file)
          this.$axios.post('vehicle/saveVehicleImage', formData)
            .then((response) => {
              this.vehicle.vehiclePhotoUrl = response.data.pictureUrl

              resolve()
            })
            .catch((error) => {
              console.log(error)
            })
        } else {
          this.vehicle.vehiclePhotoUrl = null
          resolve()
        }
      }).then(() => {
        this.$axios.post('vehicle/editVehicle', this.vehicle)
          .then((response) => {
            sessionStorage.setItem('vehicleDetail', JSON.stringify(this.vehicle))
            this.$router.push({name: 'VehicleDetail'})
          })
          .catch((error) => {
            console.log(error)
          })
      })
    },
    // 车辆block设定
    setting () {
      console.log('setting')
      if (StringUtil.isEmpty(this.vehicle.blockNote)) {
        this.vehicle.blockNote = null
      }
      this.$axios.post('vehicle/setVehicleBlock', this.vehicle)
        .then((response) => {
          sessionStorage.setItem('vehicleDetail', JSON.stringify(this.vehicle))
          this.$router.push({name: 'VehicleDetail'})
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 车辆block编辑
    blockEditor () {
      console.log('blockEditor')
      if (StringUtil.isEmpty(this.vehicle.blockNote)) {
        this.vehicle.blockNote = null
      }
      this.$axios.post('vehicle/setVehicleBlock', this.vehicle)
        .then((response) => {
          sessionStorage.setItem('vehicleDetail', JSON.stringify(this.vehicle))
          this.$router.push({name: 'VehicleDetail'})
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // saveImage (resolve) {
    //   let file = this.option.file
    //   console.log(file)
    //   let formData = new FormData()
    //   formData.append('uploadFile', file)
    //   this.$axios.post('vehicle/saveVehicleImage', formData)
    //     .then((response) => {
    //       this.vehicle.vehiclePhotoUrl = response.data.pictureUrl
    //       console.log(this.vehicle.vehiclePhotoUrl)
    //       resolve()
    //     })
    //     .catch((error) => {
    //       console.log(error)
    //     })
    // },
    getLoginDate () {
      return DateUtil.yearMonthDay(this.vehicle.joinDate)
    }
  }
}
</script>

<template>
    <div class="col-md-12 column">
        <div class="modal fade" id="modal-container-vehicle-info" data-backdrop="static" style="backdrop: 'static'" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><img height="30px" src="@/assets/button/close_button.png" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;"/></button>
                        <strong class="modal-title F3-M-27" id="myModalLabel">
                            {{title}}
                        </strong>
                    </div>
                    <div class="modal-body">
                       <div class="row clearfix">
                        <div class="col-md-4 column">
                          <div class="row clearfix">
                            <div style="background:grey;margin-left:5%">
                              <img v-if="option.img!==null" :src="option.img" style="height:234px;width:100%"/>
                              <div v-else class="noimg-style bgc10 F2-M-18">No Image</div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-8 column">
                          <table class="table table-bordered">
                            <tbody>
                              <tr v-if="vehicle.transportKind == 1">
                                <td class="td-key bgc8 F3-R-15" width=20%>
                                  交通事業者名
                                </td>
                                <td class="td-value F3-M-18" width=80%>
                                  {{vehicle.transportName}}
                                </td>
                              </tr>
                              <tr>
                                <td class="td-key bgc8 F3-R-15" width=20%>
                                  車両名
                                </td>
                                <td class="td-value F3-M-18" width=80%>
                                  {{vehicle.vehicleName}}
                                </td>
                              </tr>
                              <tr v-if="type=='block'||func=='editor'">
                                <td class="td-key bgc8 F3-R-15">
                                  車両 ID
                                </td>
                                <td class="td-value F3-M-18">
                                  {{vehicle.displayVehicleId}}
                                </td>
                              </tr>
                              <tr>
                                <td class="td-key bgc8 F3-R-15">
                                  車種
                                </td>
                                <td class="td-value F3-M-18">
                                  {{vehicle.vehicleType}}
                                </td>
                              </tr>
                              <tr>
                                <td class="td-key bgc8 F3-R-15">
                                  車両ナンバー
                                </td>
                                <td class="td-value F3-M-18">
                                  {{vehicle.vehiclePlate}}
                                </td>
                              </tr>
                              <tr>
                                <td class="td-key bgc8 F3-R-15">
                                  乗車定員
                                </td>
                                <td class="td-value F3-M-18">
                                  {{vehicle.passengerNumber}}名
                                </td>
                              </tr>
                              <tr v-if="type=='info'">
                                <td class="td-key bgc8 F3-R-15">
                                  登録日
                                </td>
                                <td class="td-value F3-M-18">
                                  {{getLoginDate()}}
                                </td>
                              </tr>
                              <tr v-if="type=='info'">
                                <td class="td-key bgc8 F3-R-15">
                                  <div class="note-div">
                                      備考
                                  </div>
                                </td>
                                <td height=100px class="td-value F3-M-18 tooLong">
                                     {{vehicle.note}}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <!-- block -->
                           <table v-if="type=='block'" class="table table-bordered">
                              <tbody>
                                <tr><td class="td-key bgc3" style="color:white" colspan="2">{{title}}</td></tr>
                                <tr>
                                  <td class="td-key bgc8 F3-R-15" width=20%>
                                    関始日
                                  </td>
                                  <td class="td-value F3-M-18" width=80%>
                                    {{blockStart.date}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{blockStart.time}}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="td-key bgc8 F3-R-15">
                                    終了日
                                  </td>
                                  <td class="td-value F3-M-18">
                                    {{blockEnd.date}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{blockEnd.time}}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="td-key bgc8 F3-R-15">
                                    <div class="note-div">
                                      備考
                                    </div>
                                  </td>
                                  <td height=100px class="td-value F3-M-18 tooLong">
                                    {{vehicle.blockNote}}
                                  </td>
                                </tr>
                              </tbody>
                           </table>
                        </div>
                      </div>

                    </div>
                    <div>
                        <div class="row clearfix">
                            <div class="col-md-3 column">
                            </div>
                            <div class="col-md-6 column">
                                <button class="vehicleinfo-mask-btn" v-if="func==='login'" data-dismiss="modal" @click="login">確定</button>
                                <button class="vehicleinfo-mask-btn" v-if="func==='editor'" data-dismiss="modal" @click="editor">確定</button>
                                <button class="vehicleinfo-mask-btn" v-if="func==='block-editor'" data-dismiss="modal" @click="blockEditor">確定</button>
                                <button class="vehicleinfo-mask-btn" v-if="func==='setting'" data-dismiss="modal" @click="setting">確定</button>
                            </div>
                            <div class="col-md-3 column">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../assets/css/C00.css";
    .modal-dialog{
        width: 70%;
    }
    .modal-header{
        border-bottom: 0px;
    }
    .modal-title{
        font-size: 28px;
    }
    .modal-body{
        padding-left: 40px;
        padding-top: 0px;
        margin-right: 10px;
    }
    .noimg-style{
      height: 245px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .note-div{
      height: 100px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .table-bordered>tbody>tr>td{
        border: 1px solid #959595;
    }
    .td-key{
        background-color: rgb(210, 210, 210);
    }
    // .table>tbody>tr>td{
    //     padding:1.2%;
    // }
    // .table>tbody>tr>.td-value{
    //     padding-left: 2.5%;
    // }
    .td-value{
        text-align: left;
        border: 1px solid #959595;
    }
    .vehicleinfo-mask-btn{
        width: 80%;
        height: 50px;
        border-radius: 10px;
        margin-top: 5%;
        margin-bottom: 30px;
        font-size: 2em;
        color: #fff;
        border: 0px;
        background:linear-gradient(rgb(112, 182, 202) 50%, rgb(72,163,190) 50%);
    }
    .close{
        opacity: 1;
    }
    .small-span{
        float: right;
        background-color: #DCDCDC;
        border-radius: 3px;
        padding-left: 15px;
        padding-right: 15px;
    }
    .modal-backdrop.in{
       opacity: 0.6;
    }
    .tooLong{
      word-wrap: break-word;
      word-break: break-all;
    }
</style>



// WEBPACK FOOTER //
// src/components/VehicleInfoWindowMask.vue